import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as AgendamentosActions } from "../ducks/agendamentos";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ModalCompromissosActions } from "../ducks/modalCompromissos";
import { Creators as ModalCompromissosEditActions } from "../ducks/modalCompromissosEdit";

export function* getAgendamentos() {
  try {
    const { data } = yield call(api.get, `/calls/calendar`);
    let pivot = [];
    data.forEach(d => {
      d.days.forEach(day => {
        pivot.push(day);
      });
    });
    yield put(AgendamentosActions.getAgendamentosSuccess(pivot));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* addAgendamentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/commitments`, payload);
    yield put(ModalCompromissosActions.closeModalCompromissos());
    yield put(
      SuccessActions.openSuccess("Compromisso adicionado com sucesso.")
    );
    yield put(AgendamentosActions.getAgendamentos());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getAgendamento({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/commitments/${payload.id}`);
    yield put(AgendamentosActions.getAgendamentoSuccess(data));
    yield put(ModalCompromissosEditActions.openModalCompromissosEdit());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editAgendamentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/commitments/${payload.id}`, payload);
    yield put(AgendamentosActions.getAgendamentos());
    yield put(ModalCompromissosEditActions.closeModalCompromissosEdit());
    yield put(SuccessActions.openSuccess("Compromisso editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* excluirAgendamentos() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.agendamentos.item);
    yield put(ModalCompromissosEditActions.closeModalCompromissosEdit());
    yield call(api.delete, `/commitments/${id}`);
    yield put(AgendamentosActions.getAgendamentos());
    yield put(SuccessActions.openSuccess("Compromisso excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/agendamentos.js